/**
 *
 * @param {ApiManager.IWorkplan[] | undefined} listA
 * @param {ApiManager.IWorkplan[] | undefined} listB
 * @returns {boolean}
 */
// eslint-disable-next-line import/prefer-default-export
export const isWorkplanShiftlinesModified = (listA, listB) => {
    if (!listA && !listB) {
        return false;
    } if (!listA || !listB) {
        return true;
    }
    const getSelectedItems = (list) => list.flatMap((x) => x.scheduleTemplates.items.reduce((prev, curr) => {
        if (curr.isSelected) {
            prev.push(curr.id);
        }
        return prev;
    }, []));

    const selectedItemsIdsInA = getSelectedItems(listA);
    const selectedItemsIdsInB = getSelectedItems(listB);

    const aMinusB = selectedItemsIdsInA.filter((x) => !selectedItemsIdsInB.includes(x));
    const bMinusA = selectedItemsIdsInB.filter((x) => !selectedItemsIdsInA.includes(x));

    const diff = aMinusB.concat(bMinusA);

    return !!diff.length;
};

/**
 * @param {ManagerAppData.IManagerBidSetup[]} managerBidSetups
 * @param {number|undefined} bidSetupId
 */
export const getIsAllowBidOnActiveWorkplan = (managerBidSetups, bidSetupId) => {
    if (!bidSetupId) {
        return false;
    }
    const value = managerBidSetups.find((x) => x.bidSetupId === bidSetupId);
    if (!value) {
        return null;
    }
    return value.isAllowBidOnActiveWorkplan;
};
